import { render, staticRenderFns } from "./EditKeywordDialog.vue?vue&type=template&id=7f35dc65"
import script from "./EditKeywordDialog.vue?vue&type=script&lang=js"
export * from "./EditKeywordDialog.vue?vue&type=script&lang=js"
import style0 from "./EditKeywordDialog.vue?vue&type=style&index=0&id=7f35dc65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports